import React from "react";
import {
	PolarChart,
	CommonSeriesSettings,
	Series,
	Legend,
	ArgumentAxis,
	ValueAxis,
	Size,
	Label,
	Tooltip,
	Point,
	Border,
	Font,
	MinorGrid,
} from "devextreme-react/polar-chart";
import {CommonAxisSettings} from "devextreme-react/chart";
import {useAppStore} from "../../../common/app.store.consumer";
import {ReportChartComponent} from "../types/report.chart.component";

const ReportChartSpiderWeb: React.FC<ReportChartComponent & { isPdf?: boolean }> = useAppStore()((props: ReportChartComponent & { isPdf?: boolean }) => {
	const store = props.appStore.reportPageStore;
	const isPdf = props.isPdf ? props.isPdf : false;

	function customizeTooltip(pointInfo) {
		return {
			text: `${Math.round(pointInfo.value)} %`
		};
	}

	return (
		<PolarChart id="polar-chart" dataSource={store.taxonomyOrderedAnswerSheetDetails.map((data) => ({
			arg: data.taxonomyName + `\n(${data.score * 100}%)`,
			score: (data.score) * 100
		}))}>
			<CommonSeriesSettings color="#3DC2A7" type="area" hoverMode="none">
				<Border visible={true} color="#3DC2A7"></Border>
				<Point color="white" visible={true} size={5} hoverMode="none">
					<Border visible={true} color="#3DC2A7" width={2}></Border>
				</Point>
			</CommonSeriesSettings>
			<CommonAxisSettings>
				<Label indentFromAxis={16}>
					<Font family="Roboto" size={isPdf ? 13 : 16}></Font>
				</Label>
			</CommonAxisSettings>
			<ArgumentAxis firstPointOnStartAngle={true} discreteAxisDivisionMode="crossLabels"/>
			<Series key={"score"} valueField={"score"} name={"Score"}/>
			<Tooltip enabled={true} customizeTooltip={customizeTooltip}>
				<Font size={16} weight="bold" color="#333333"/>
			</Tooltip>
			<Legend visible={false}/>
			<ValueAxis visible={false} visualRange={[0, 100]} tickInterval={20 as any}>
				<MinorGrid visible={false}></MinorGrid>
				<Label visible={false}/>
			</ValueAxis>
			<Size width={isPdf ? 310 : "100%"} height={isPdf ? 300 : 350}/>
		</PolarChart>
	);
});
export default ReportChartSpiderWeb;
